import { observer } from 'mobx-react';
import React from 'react';

import { ScrollToTypography } from '../../../components/scroll-to/scroll-to-typography';
import { Spinner } from '../../../components/spinner';
import { ApiError } from '../../../core/api/api-error';
import { ConnectApiErrorResponseDto } from '../../../core/api/dtos';
import { injectTSDI } from '../../../core/common/tsdi';
import { containsErrorWithCode } from '../../../core/common/utils';
import { I18n } from '../../../core/i18n';
import { ContractWithdrawalStore } from '../contract-withdrawal-store';
import { ManualWithdrawalSuccessPage } from './manual-withdrawal-success-page';

export const ManualWithdrawalSuccessPageContainer = observer(() => {
    const { translate } = injectTSDI(I18n);
    const { withdrawContractManualRequest } = injectTSDI(
        ContractWithdrawalStore
    );

    return withdrawContractManualRequest.match({
        loading: () => <Spinner />,
        fetched: (manualWithdrawal) => (
            <ManualWithdrawalSuccessPage manualWithdrawal={manualWithdrawal} />
        ),
        error: (e: ApiError) => {
            let errorCode = 'public.content.withdraw.contract.error';
            const errors = e.errorMessages as ConnectApiErrorResponseDto[];
            if (errors) {
                if (containsErrorWithCode('SERVER_ERROR', errors)) {
                    errorCode = 'public.content.withdraw.contract.error';
                } else if (
                    containsErrorWithCode(
                        'OPERATION_NOT_ALLOWED_FOR_STUDIO',
                        errors
                    )
                ) {
                    errorCode =
                        'public.content.withdraw.contract.no.online.offers';
                } else if (containsErrorWithCode('FEATURE_DISABLED', errors)) {
                    errorCode = 'public.content.withdraw.disabled';
                }
            }
            return (
                <ScrollToTypography
                    color="error"
                    data-value={errorCode}
                    data-role="error-container"
                >
                    {translate(errorCode)}
                </ScrollToTypography>
            );
        },
        default: () => <></>
    });
});
